<script setup lang="ts">
import { TypographyItem, TypographyWithPrefix } from '@/components/Typography'
import { computed, ref } from 'vue'
import { IconButton } from '../Buttons'

type Props = {
    label?: string
}
const props = defineProps<Props>()
type Emits = {
    (e: 'click', value: boolean): void
}
const emit = defineEmits<Emits>()

const isShowing = ref(false)
const icon = computed(() => (isShowing.value ? 'eye-slash' : 'eye'))
const currentLabel = computed(() => (isShowing.value ? props.label : '**********'))

const handleIconClick = () => {
    emit('click', !isShowing.value)
    isShowing.value = !isShowing.value
}

const resetShowable = () => (isShowing.value = false)

defineExpose({ resetShowable })
</script>

<template>
    <TypographyWithPrefix
        v-bind="$attrs"
        class="align-items-center"
        :style="{ 'flex-direction': 'row' }">
        <TypographyItem :label="currentLabel" />

        <template #edit>
            <IconButton :icon="icon" class="clickable-icon" @click="handleIconClick" />
        </template>
    </TypographyWithPrefix>
</template>

<style scoped lang="scss">
.clickable-icon {
    cursor: pointer;
    color: $primary;
    border: unset;
}
</style>
